"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownHeading = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _DropdownHeading = require("./DropdownHeading.styles");
var _excluded = ["children", "icon", "level"];
/**
 * A header for the `Dropdown` component.
 *
 * @extends Flex
 * @related [`DropdownButton`, `DropdownIcon`, `DropdownPopper`]
 * @since 8.60.0
 */
var DropdownHeading = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    icon = _ref.icon,
    level = _ref.level,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_DropdownHeading.StyledDropdownHeading, (0, _extends2.default)({
    as: "h" + level,
    ref: forwardedRef,
    display: "flex",
    alignItems: "center"
  }, rest), icon, children);
});
exports.DropdownHeading = DropdownHeading;
DropdownHeading.displayName = 'DropdownHeading';
DropdownHeading.propTypes = {
  /**
   * An optional `Icon` node.
   */
  icon: _propTypes.default.node,
  /**
   * A string or number representing the heading level
   */
  level: _propTypes.default.oneOf(['1', '2', '3', '4', '5', '6', 1, 2, 3, 4, 5, 6])
};
DropdownHeading.defaultProps = {
  level: 6
};